export default __webpack_public_path__ + "static/media/input-error-icon.c807c6fb.svg";